import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/auth.context';
import LoginLoader from './login-loader.component';

const LogoutCallback = () => {
  const { t } = useTranslation();
  const { signoutRedirectCallback } = useAuth();
  // This effect wipes storage and redirects, so it must run exactly once. The dependency
  // array alone is not enough of a guarantee: AuthProvider rebuilds its context value on
  // every render, and the callback is only stable today because it is an arrow property on
  // a singleton. A ref keeps it to one run regardless, and covers StrictMode's double
  // effect invocation.
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) {
      return;
    }
    hasRun.current = true;
    signoutRedirectCallback();
  }, [signoutRedirectCallback]);

  return <LoginLoader title={t(($) => $.redirectingToLogin)} />;
};
export default LogoutCallback;
